import { i18nextContainer } from 'shared/configs/i18n/config'
import z from 'zod'

export const PASSWORD_RULES = [
  {
    key: 'length',
    test: (value: string) => value.length >= 12 && value.length <= 20
  },
  { key: 'lowercase', test: (value: string) => /[a-z]/.test(value) },
  { key: 'uppercase', test: (value: string) => /[A-Z]/.test(value) },
  { key: 'digit', test: (value: string) => /\d/.test(value) },
  { key: 'special', test: (value: string) => /[^a-zA-Z0-9]/.test(value) }
] as const

export const passwordSchema = z
  .string()
  .refine(value => PASSWORD_RULES.every(rule => rule.test(value)), {
    message: i18nextContainer.t('common:validation.password')
  })
